import { Card, CardBody, Col, Table, Button, Container, Row } from "reactstrap";
import TabPlusIcon from "mdi-react/TabPlusIcon";
import DeptListTable from "./DeptListTable";
import { useHistory } from "react-router";
import { decryption } from "../../../HelperFunctions";
import BreadCrumb from "../../../../shared/components/BreadCrumb/BreadCrumb";

const Department = () => {
  const history = useHistory();
  // permission
  const permissions = decryption(
    JSON.parse(localStorage?.getItem("permissions"))
  );
  const breadCrumbData = [
    {
      name: "Dashboard",
      link: "/",
    },
    {
      name: "Department",
    },
  ];
  return (
    <Col md={12}>
      <Card>
        <CardBody>
          <Row>
            <Col>
              <BreadCrumb breadCrumbData={breadCrumbData} />
            </Col>
          </Row>
          <Row>
            <Col md={6} className="d-flex align-items-center">
              <h3 className="page-title mb-0">Department List</h3>
            </Col>
            <Col
              md={6}
              className="d-flex justify-content-end align-items-center"
            >
              {permissions?.includes("create_department") && (
                <Button
                  onClick={() => history.push("/department/new")}
                  color="primary"
                >
                  <TabPlusIcon className="mr-1" />
                  New Department
                </Button>
              )}
            </Col>
          </Row>
          <Row>
            <DeptListTable />
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default Department;
